import { render } from "./App.vue?vue&type=template&id=d9eccfea"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d9eccfea&lang=scss"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__